import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

// 用来存储数据
const state = {
  loginState: localStorage.getItem('isLogin') || '',
  token: localStorage.getItem('token') || ''
}
// 响应组件中的事件
const actions = {

}
// 操作数据
const mutations = {
  updateUserState (_, token) {
    this.state.loginState = '已登录2'
    this.state.token = token
  }
}
// 用来将state数据进行加工
const getters = {

}
// 新建并暴露store
export default new Vuex.Store({
  state,
  actions,
  mutations,
  getters
})
